import { render, staticRenderFns } from "./CommercialEdit.vue?vue&type=template&id=06a4f199&"
import script from "./CommercialEdit.vue?vue&type=script&lang=js&"
export * from "./CommercialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports